import React from 'react';
import styles from './Footer.scss';
import InlineSVG from 'react-svg-inline';
import twitterIcon from '../../imgs/twitter-icon.svg';
import vkIcon from '../../imgs/vk-icon.svg';
import fbIcon from '../../imgs/fb-icon.svg';


export default function FooterMobile() {
  return (
    <div className={styles.footer}>
      <div className={styles.linksContainer}>
        <a href="#">Помощь</a>
        <a href="#">Партнерам</a>
        <a href="#">Контакты</a>
      </div>

      <div style={{
          textAlign: 'center',
          marginTop: '16px'
        }}>
        <div className={styles.shareIconsContainer}>
          <a href="#"><InlineSVG svg={twitterIcon} /></a>
          <a href="#"><InlineSVG svg={vkIcon} /></a>
          <a href="#"><InlineSVG svg={fbIcon} /></a>
        </div>

        <div className={styles.contacts}>
          <p className={styles.text}>+7 (495) 123-4567</p>
          <a href="mailto:order@ketex.ru">order@ketex.ru</a>
        </div>
      </div>


    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Footer/FooterMobile.jsx
 **/